import { HttpClient } from "@angular/common/http";
import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { take } from "rxjs/operators";
import {
  landingPageConfig,
  scrollToTop,
  yasomiCompanyId
} from "src/app/helpers/helpers";

@Component({
  selector: "app-survey-thanks",
  templateUrl: "./survey-thanks.component.html",
  styleUrls: ["./survey-thanks.component.scss"]
})
export class SurveyThanksComponent implements OnInit, OnDestroy {
  public static hideLatestSurveyHref = true;

  @Input() smsNavState: any;

  navState: any;
  conf: any;
  _yasomiCompanyId = yasomiCompanyId;
  productLinksModalShowing = false;
  qrImage = null;

  get logoSrc() {
    if (this.conf?.key === "hummel-2" || this.conf?.key === "hummel") {
      return `/assets/lp/hummel/logo.png`;
    }
    return `/assets/lp/${this.conf?.key}/logo.png`;
  }

  get linkButtonText() {
    if (this.navState?.landingPageKey) {
      return this.conf?.linkButtonText || "";
    }
    return "Ankete Git";
  }

  get showLinkButton() {
    return true;
  }

  get lpTopLeftSrc() {
    if (this.isPeynirciSerdivan) {
      return `/assets/lp/${this.conf?.key}/top-right-thanks.png`;
    }
    return `/assets/lp/${this.conf?.key}/top-left-thanks.png`;
  }

  get isPeynirci() {
    return this.navState?.landingPageKey === "peynirci";
  }

  get isKolektif() {
    return this.navState?.landingPageKey === "kolektif";
  }

  get isPeynirciSerdivan() {
    return (
      this.isPeynirci &&
      (this.router.url.includes("serdivan") ||
        this.smsNavState?.isPeynirciSerdivan)
    );
  }

  get isMed() {
    return this.navState?.landingPageKey === "med";
  }

  get isNesPilates() {
    return this.navState?.landingPageKey === "nespilates";
  }

  constructor(
    private _sanitizer: DomSanitizer,
    private router: Router,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    scrollToTop();
    this.navState =
      this.smsNavState ||
      JSON.parse(localStorage.getItem(this.router.url) || "{}");

    if (
      !this.navState.landingPageKey &&
      window.location.host.startsWith("localhost")
    ) {
      this.navState = {
        landingPageKey: "kolektif",
        earningId: "1234567890"
      };
    }

    if (this.navState?.landingPageKey) {
      localStorage.removeItem(this.router.url);
      this.conf = landingPageConfig.find(
        (m) => m.key === this.navState.landingPageKey
      );
      if (
        this.navState?.landingPageKey === "peynirci" ||
        this.isMed ||
        this.isNesPilates
      ) {
        this.getQr(this.navState.earningId);
      }
    }

    if (this.conf) {
      document.body.classList.add(this.conf.key);
    }
  }

  ngOnDestroy(): void {
    if (this.conf) {
      document.body.classList.remove(this.conf.key);
    }
  }

  goLink() {
    if (!this.conf) {
      return;
    }

    if (this.navState?.landingPageKey) {
      if (this.isPeynirciSerdivan) {
        window.open("https://maps.app.goo.gl/gyrdwAzMNdV4pta56", "_blank");
      } else if (this.isMed) {
        window.open("https://maps.app.goo.gl/sd6fqvJVF7yYJ4ms8", "_blank");
      } else {
        window.open(this.conf.linkButtonHref, "_blank");
      }
    } else {
      this.router.navigateByUrl(
        this.router.url.replace("/tesekkurler/", "").replace("/tesekkurler", "")
      );
    }
  }

  getBackground() {
    return this._sanitizer.bypassSecurityTrustStyle(
      `url(${this.navState?.qrBackground})`
    );
  }

  getQr(earningId: string) {
    this.http
      .post("/getQR", {
        id: `E=${earningId || ""}`,
        noSpacing: true
      })
      .pipe(take(1))
      .subscribe((res: any) => {
        this.qrImage = res.qr;
      });
  }
}
